<template>
  <section class="cta-section">
    <div class="container">
      <div class="cta-content">
        <h2 class="cta-title">Todo para terminar tu novela, gratis</h2>
        <p class="cta-description">
          Editor, organizador de tramas, fichas de personajes, versionamiento y lectores beta. Sin
          IA leyendo tu obra.
        </p>
        <div class="cta-buttons">
          <v-btn
            class="cta-button primary large"
            size="x-large"
            rounded="lg"
            @click="$emit('start-writing')"
          >
            <v-icon left>mdi-pencil</v-icon>
            Registrarse gratis
          </v-btn>
          <p class="cta-note">
            <v-icon size="16" class="mr-1">mdi-information</v-icon>
            Sin tarjeta • Empieza ahora
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HomeCtaSection',

  emits: {
    'start-writing': () => true,
  },
})
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.cta-section {
  background: linear-gradient(135deg, #1d3557, #457b9d);
  color: white;
  padding: 5rem 0;
}

.cta-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.cta-description {
  font-size: 1.2rem;
  opacity: 0.9;
  margin-bottom: 2.5rem;
}

.cta-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.cta-button {
  font-weight: 600;
  text-transform: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.cta-button.primary {
  background: linear-gradient(45deg, #1d3557, #457b9d) !important;
  color: white;
}

.cta-button.large {
  background: linear-gradient(45deg, #ff9f1c, #e9c46a) !important;
  color: #1d3557;
  font-size: 1.2rem;
  padding: 1rem 2rem;
}

.cta-note {
  font-size: 0.9rem;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
}

@media (max-width: 480px) {
  .cta-title {
    font-size: 2rem;
  }
}
</style>
